import React, { useState } from 'react';
import { X } from 'lucide-react';
const COUNTRIES = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo (DRC)', 'Congo (Republic)', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'];
interface GuideFormPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export const GuideFormPopup = ({
  isOpen,
  onClose
}: GuideFormPopupProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: '',
    city: '',
    budget: '',
    goal: '',
    timeline: ''
  });
  if (!isOpen) return null;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await fetch('https://hooks.zapier.com/hooks/catch/12304964/upn55f2/', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          formType: 'investor_guide'
        })
      });
    } catch (err) {
      console.error('Webhook error:', err);
    }
    setIsSubmitting(false);
    window.open('https://ikigaire.ae/wp-content/uploads/2026/03/WHY-DUBAI.pdf', '_blank');
    onClose();
    setFormData({
      fullName: '',
      email: '',
      phone: '',
      country: '',
      city: '',
      budget: '',
      goal: '',
      timeline: ''
    });
  };
  const selectStyle = {
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
    backgroundPosition: 'right 0.5rem center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5em 1.5em',
    paddingRight: '2.5rem'
  };
  const inputClasses = 'w-full px-4 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#d8a34d]/20 focus:border-[#d8a34d] outline-none transition-all text-gray-900 bg-gray-50/50 focus:bg-white';
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-278">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-279" />

      {/* Modal Content */}
      <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" data-id="element-280">
        {/* Header */}
        <div className="px-6 py-5 border-b border-gray-100 flex justify-between items-start bg-white" data-id="element-281">
          <div data-id="element-282">
            <h3 className="text-xl md:text-2xl font-display font-bold text-[#1a2e1c] leading-tight pr-8" data-id="element-283">
              Download Dubai Property Investment Guide (2026)
            </h3>
            <div className="w-12 h-1 bg-[#d8a34d] mt-3 rounded-full" data-id="element-284"></div>
          </div>
          <button onClick={onClose} className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100" aria-label="Close modal" data-id="element-285">
            <X className="w-5 h-5" data-id="element-286" />
          </button>
        </div>

        {/* Form Body */}
        <div className="overflow-y-auto p-6" data-id="element-287">
          <form id="guide-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-288">
            {/* Full Name */}
            <div className="space-y-1.5" data-id="element-289">
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-700" data-id="element-290">
                Full Name *
              </label>
              <input type="text" id="fullName" name="fullName" required value={formData.fullName} onChange={handleChange} className={inputClasses} placeholder="John Doe" data-id="element-291" />
            </div>

            {/* Email */}
            <div className="space-y-1.5" data-id="element-292">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-293">
                Email Address *
              </label>
              <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className={inputClasses} placeholder="john@example.com" data-id="element-294" />
            </div>

            {/* Phone */}
            <div className="space-y-1.5" data-id="element-295">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-296">
                Phone Number *
              </label>
              <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className={inputClasses} placeholder="+1 (555) 000-0000" data-id="element-297" />
            </div>

            {/* Country */}
            <div className="space-y-1.5" data-id="element-298">
              <label htmlFor="country" className="block text-sm font-medium text-gray-700" data-id="element-299">
                Country of Residence *
              </label>
              <select id="country" name="country" required value={formData.country} onChange={handleChange} className={`${inputClasses} appearance-none`} style={selectStyle} data-id="element-300">
                <option value="" disabled data-id="element-301">
                  Select your country
                </option>
                {COUNTRIES.map(c => <option key={c} value={c} data-id="element-302">
                    {c}
                  </option>)}
              </select>
            </div>

            {/* City (optional) */}
            <div className="space-y-1.5" data-id="element-303">
              <label htmlFor="city" className="block text-sm font-medium text-gray-700" data-id="element-304">
                City
              </label>
              <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className={inputClasses} placeholder="New York" data-id="element-305" />
            </div>

            {/* Investment Budget (optional) */}
            <div className="space-y-1.5" data-id="element-306">
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700" data-id="element-307">
                Investment Budget
              </label>
              <select id="budget" name="budget" value={formData.budget} onChange={handleChange} className={`${inputClasses} appearance-none`} style={selectStyle} data-id="element-308">
                <option value="" data-id="element-309">Select a budget range</option>
                <option value="USD 545K - 600K" data-id="element-310">USD 545K - 600K</option>
                <option value="USD 600K - 1M" data-id="element-311">USD 600K - 1M</option>
                <option value="USD 1M+" data-id="element-312">USD 1M+</option>
              </select>
            </div>

            {/* Investment Goal (optional) */}
            <div className="space-y-1.5" data-id="element-313">
              <label htmlFor="goal" className="block text-sm font-medium text-gray-700" data-id="element-314">
                Investment Goal
              </label>
              <select id="goal" name="goal" value={formData.goal} onChange={handleChange} className={`${inputClasses} appearance-none`} style={selectStyle} data-id="element-315">
                <option value="" data-id="element-316">Select your primary goal</option>
                <option value="Rental Income" data-id="element-317">Rental Income</option>
                <option value="Capital Appreciation" data-id="element-318">
                  Capital Appreciation
                </option>
                <option value="Golden Visa" data-id="element-319">Golden Visa</option>
                <option value="Holiday Home" data-id="element-320">Holiday Home</option>
              </select>
            </div>

            {/* Purchase Timeline (optional) */}
            <div className="space-y-1.5" data-id="element-321">
              <label htmlFor="timeline" className="block text-sm font-medium text-gray-700" data-id="element-322">
                Purchase Timeline
              </label>
              <select id="timeline" name="timeline" value={formData.timeline} onChange={handleChange} className={`${inputClasses} appearance-none`} style={selectStyle} data-id="element-323">
                <option value="" data-id="element-324">Select your timeline</option>
                <option value="Immediately" data-id="element-325">Immediately</option>
                <option value="3-6 Months" data-id="element-326">3-6 Months</option>
                <option value="6-12 Months" data-id="element-327">6-12 Months</option>
                <option value="Just Exploring" data-id="element-328">Just Exploring</option>
              </select>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50" data-id="element-329">
          <button type="submit" form="guide-form" disabled={isSubmitting} className="w-full btn-gold px-6 py-3.5 rounded-lg font-bold text-base shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-330">
            {isSubmitting ? <>
                <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-331">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-332"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-333"></path>
                </svg>
                Processing...
              </> : 'Download Free Guide'}
          </button>
          <p className="text-center text-xs text-gray-500 mt-3" data-id="element-334">
            Your information is secure. We respect your privacy.
          </p>
        </div>
      </div>
    </div>;
};